import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery, transformErrorResponse, transformErrorResponseWithMessage, transformResponse } from "../../baseQuery";

export const StudyAbroadCoursesApiSlice = createApi({
    reducerPath: "StudyAbroadCoursesApiSlice",
    baseQuery,

    tagTypes: ["studyAbroadCourses", "subjectNames"],

    endpoints: (builder) => ({

        getStudyAbroadCoursesApi: builder.query({
            query: () => ({
                url: 'studyAbroadCourse/user',
                method: "GET",
            }),
            transformResponse,
            transformErrorResponse: transformErrorResponseWithMessage,
            providesTags: ["studyAbroadCourses"]
        }),

        getCourseWithSubjectNamesApi: builder.query({
            query: (searchTextValue ) => ({
                url: 'studyAbroadCourse/userGetCourseWithSubjectNames',
                method: "GET",
                params:searchTextValue
            }),
            transformResponse,
            transformErrorResponse: transformErrorResponseWithMessage,
            providesTags: ["subjectNames"]
        }),

    }),
});

export const {
    useGetStudyAbroadCoursesApiQuery,
    useGetCourseWithSubjectNamesApiQuery
} = StudyAbroadCoursesApiSlice; 